// extracted by mini-css-extract-plugin
module.exports = {"infoAlert":"Login_infoAlert__UA1RT","infoIcon":"Login_infoIcon__2jYVt"};